<template>
    <div class="clip-mask" ref="clip">
      <transition mode="out-in">
        <div :key="label">
          <p class="p-absolute"><span>{{ label }}</span></p>
        </div>
      </transition>
      <p v-if="masked" :class="['p-absolute', `clip-path-${index}`]"><span>{{ label }}</span></p>
    </div>
</template>

<script>
// eslint-disable-next-line
import gsap from 'gsap'

export default {
  name: 'ClipMask',
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    masked: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      index: 1,
      paths: 3
    }
  },
  created () {
    this.index = this.getRandomInt(1, this.paths)
  },
  watch: {
    label () {
      let nextPath = this.index + 1
      if (nextPath > this.paths) nextPath = 1
      this.index = nextPath

      const { clip } = this.$refs
      clip.style.opacity = 0
      gsap.killTweensOf(clip)

      gsap.to(clip, {
        duration: 3,
        delay: 0.15,
        ease: 'expo.out',
        opacity: 1
      })
    }
  },
  methods: {
    getRandomInt (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    }
  }
}
</script>

<style lang="scss" scoped>

.clip-path-1 {
  clip-path: polygon(27% 36%, 52% 19%, 78% 17%, 85% 44%, 84% 65%, 67% 85%, 30% 91%, 9% 83%);
}

.clip-path-2 {
  clip-path: polygon(41% 21%, 59% 12%, 79% 22%, 88% 59%, 81% 88%, 63% 63%, 46% 47%, 28% 57%);
}

.clip-path-3 {
  clip-path: polygon(24% 21%, 64% 13%, 77% 35%, 67% 87%, 60% 48%, 46% 59%, 36% 88%, 28% 57%);
}

.clip-mask {
  position: fixed;
  pointer-events: none;
  top: -1vh;
  left: 0;
  font-size: 6.5vw;
  font-family: 'BrotherHome', serif;
  font-weight: normal !important;
  letter-spacing: 0.2em !important;
  line-height: 2.2em;
  color: #000;
  width: 100%;
  text-align: left;
  opacity: 1;
  white-space: nowrap;

  &.full {
    p {
      &:nth-child(1) {
        opacity: 0.1;
      }

      &:nth-child(2) {
        opacity: 1;
      }
    }
  }

  p {
    top: 0;
    left: 0;
    width: 100%;
    transition: opacity 2s 0s $ease-in-out-expo;

    &:nth-child(1) {
      opacity: 0.05;
    }

    &:nth-child(2) {
      opacity: 0.45;
    }

    span {
      position: relative;
      display: inline-block;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

</style>
